<template>
  <section class="page-container">
    <h1>Hold Dollar Activity</h1>
    <!--    <div class="filter-container">-->
    <!--      <div class="flex">-->
    <!--        <div class="filter-box">-->
    <!--          <span class="label">Search</span>-->
    <!--          <div class="search-box">-->
    <!--            <v-input-->
    <!--              v-model="search"-->
    <!--              placeholder="Quotation No., Customer Name, Insurer, Referrer or Price"-->
    <!--              @keyEnter="filterData" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <div class="filter-box">-->
    <!--          <span class="label">Quote Date</span>-->
    <!--          <div class="search-box">-->
    <!--            <v-date-picker-->
    <!--              v-model="date"-->
    <!--              type="daterange"-->
    <!--              @change="filterData" />-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="filter-box">-->
    <!--        <span class="label">-->
    <!--          Product Type-->
    <!--          <span-->
    <!--            class="all"-->
    <!--            @click="handlerSelectAll('product_id')">Select All</span>-->
    <!--        </span>-->
    <!--        <v-checkbox-group-->
    <!--          v-model="product_id"-->
    <!--          :list="productTypeOptions"-->
    <!--          @change="filterData"></v-checkbox-group>-->
    <!--      </div>-->
    <!--      <div class="filter-box">-->
    <!--        <span class="label">-->
    <!--          Insurer-->
    <!--          <span-->
    <!--            class="all"-->
    <!--            @click="handlerSelectAll('company_id')">Select All</span>-->
    <!--        </span>-->
    <!--        <v-checkbox-group-->
    <!--          v-model="company_id"-->
    <!--          :list="insurerOptions"-->
    <!--          @change="filterData"></v-checkbox-group>-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="filter-card">
      <div class="filter-top">
        <span class="search-title">Search</span>
        <v-input
          v-model="search"
          placeholder="Policy No., Customer Name, Insurer, Referrer or Price"
          @keyEnter="filterData"/>
      </div>
      <div class="filter-main">
        <div class="filter-left">
          <div class="form-item">
            <span>Date</span>
            <v-date-picker
              v-model="date"
              type="daterange"
              @change="filterData"/>
          </div>
          <div class="form-item " >
            <span>Amount</span>
            <div class="inline-input">
              <v-input
                v-model="amount_start"
                type="number"
                @keyEnter="filterData"></v-input>
              <span class="to-span">to</span>
              <v-input
                v-model.number="amount_end"
                type="number"
                @keyEnter="filterData"></v-input>
            </div>
          </div>

        </div>
        <div class="filter-middler">
          <div class="form-item">
            <span>
              Action Type
              <span
                class="all"
                @click="handlerSelectAll(globalOptions.credit_action)">All</span>
              <span
                class="all"
                @click="handlerNoneAll('action_type')">None</span>
            </span>
            <v-checkbox-group
              v-model="action_type"
              :list="globalOptions.credit_action"
              :isColumn="false"
              @change="filterData"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="transparent-block">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-row-class-name="'tableHeader'"
        @row-click="rowClick"
      >
        <el-table-column
          label="Time">
          <template #default="{ row }">
            <span class="action-title">{{ row.created_date }}</span><br>
            <span>{{ row.created_time }}</span><br>
          </template>
        </el-table-column>
        <el-table-column
          label="Customer">
          <template #default="{ row }">
            <div @click="rowClick(row)">
              <router-link
                :to="hanldeRouter(row)"
                class="router-row">
                <span class="action-title blue">{{ row.isrd_nm }}</span><br>
                <span class="span-tip">#{{ row.customer_id }}</span><br>
              </router-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="400"
          label="Event">
          <template #default="{ row }">
            <span class="action-title">{{ row.action_language }}</span><br>
            <span v-if="row.name">{{ row.name }}</span><br  v-if="row.name">
            <span v-if="row.describe">{{ row.describe }}</span><br  v-if="row.describe">
          </template>
        </el-table-column>
        <el-table-column
          label="HD">
          <template #default="{ row }">
            <span :class="row.credits < 0?'red':'black'">{{row.credits > 0?'+':''}}{{ row.credits | formatMoney(2, true)  }}</span><br>
          </template>
        </el-table-column>
        <el-table-column width="50">
          <template #default="{ row }">
            <font-awesome-icon
              icon="info-circle"
              class="pointer icon-info"
              @click="showDetail(row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      @currentChange="currentChange"/>

    <holddollar-detail
      ref="hd-detail"
      :detailData="detailData"></holddollar-detail>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import {getReferralRewardsList} from '@/api/refer'
import MixinFormat from '@/mixins/format'
import {mapActions, mapState} from 'vuex'
import HolddollarDetail from '@/views/components/dialogs/holddollar-detail'

export default {
  name: 'Referral',
  components:{
    HolddollarDetail
  },
  mixins: [MixinOptions,MixinFormat],
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10
      },
      date: [],
      product_id: [],
      company_id: [],
      stts: [],
      search: '',
      tableData: [],
      action_type:[],
      amount_start:'',
      amount_end:'',
      detailData: {}
    }
  },
  computed:{
    ...mapState('filter', ['selectFilterData']),
  },
  watch: {
    property: {
      immediate: true,
      handler() {
        let {referral={}} =  this.selectFilterData||{}
        Object.keys(referral).forEach(item=>{
          this[item] = referral[item]
        })
        this.setFilterData(referral||{})

        this.network().getReferralRewardsList()
      }
    }
  },
  methods: {
    ...mapActions('filter', ['setFilterData']),
    rowClick(row) {
      let params = {
        search:this.search,
        date: this.date,
        action_type: this.action_type,
        amount_start:this.amount_start,
        amount_end:this.amount_end,
        pageConfig:this.pageConfig
      }
      this.setFilterData({referral:params})

      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: row.customer_id,
          referral: true
        }
      })
    },
    hanldeRouter(row){
      return {
        path: '/accounts/detail',
        query: {
          customer_id: row.customer_id,
          referral: true
        }
      }
    },
    handlerSelectAll(list) {
      const data = list.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      this.action_type = data
      this.filterData()
    },
    handlerNoneAll(target){
      this[target] = []
      this.filterData()
    },
    filterData() {
      this.pageConfig.currentPage = 1
      this.network().getReferralRewardsList()
    },
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getReferralRewardsList()
    },
    showDetail(row){
      event.stopPropagation()
      const {id, action} = row
      this.detailData = {
        id,
        action
      }
      this.$refs['hd-detail'].changeDialog()
    },
    network() {
      return {
        getReferralRewardsList: async () => {
          const {data} = await getReferralRewardsList({
            refer_dt_start: this.date[0],
            refer_dt_end: this.date[1],
            // product_id: this.product_id,
            action_type: this.action_type,
            search: this.search,
            page: this.pageConfig.currentPage,
            amount_start:this.amount_start,
            amount_end:this.amount_end
          })
          this.tableData = data.data
          this.pageConfig.total = data.total
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  position: relative;
  color: #303133;

  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }

  h1 {
    // margin-bottom: 20px;
    font-size: 34px;
  }

  .filter-container {
    .filter-box {
      margin-bottom: 10px;

      .label {
        display: block;
        padding-bottom: 5px;
        font-size: 14px;
        font-weight: bold;

        .all {
          display: inline-block;
          padding-left: 15px;
          color: #409eff;
          font-weight: 500;
          cursor: pointer;
        }
      }

      .search-box {
        margin-right: 20px;
        width: 400px;
      }

      .quote-box {
        width: 300px;
      }
    }
  }

  .filter-card {
    margin-bottom: 32px;
    background: white;
    border: 1px solid #E1E4E8;
    border-radius: 5px;

    .filter-top {
      display: flex;
      align-items: center;
      padding: 15px;
      border-bottom: 1px solid #E1E4E8;

      & > span {
        display: inline-block;
        padding-right: 10px;
        font-weight: 500;
      }
    }

    .filter-main {
      display: flex;
      padding: 0 15px;

      .all {
        display: inline-block;
        padding-left: 15px;
        color: #409eff;
        cursor: pointer;
      }

      .filter-left, .filter-middler, .filter-right {
        padding: 15px 0;
      }

      .filter-left {
        padding-right: 10px;
        width: 290px;
        min-width: 290px;
      }

      .filter-middler {
        padding: 15px 10px;
        border-left: 1px solid #E1E4E8;
        //border-right: 1px solid #E1E4E8;
        //width: 300px;
      }

      .filter-right {
        padding-left: 10px;
      }
    }

  }

  .inline-input {
    display: flex;
    align-items: center;

    .to-span {
      margin: 0 10px;
    }
  }

  .transparent-block {
    border: 1px solid #E1E4E8;
    //border-bottom: 0;
    border-radius: 5px;
  }

  ::v-deep .tableHeader {
    background: #F6F8FA !important;

    th {
      background-color: #F6F8FA !important;
      font-family: Inter;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      letter-spacing: -0.15px;
      /* Text/text-gray-dark */
      color: #24292E!important;
    }
  }
  .name-title{
    color: #24292E;
    font-weight: bold;
  }
  .router-row{
    text-decoration: none;
    .span-tip{
      color: #6A737D;
    }
  }
  .action-title{
    color: #24292E;
    font-weight: 500;
    &.blue{
      color: #0366D6;
      cursor: pointer;
    }
  }
  .red{
    color: #CB2431;
  }
  .black{
    color: #28A745;
  }
  .icon-info{
    color: #0366D6;
  }
}
::v-deep .el-input{
  input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{

    -webkit-appearance: none !important;

  }/* chrome */

  input[type="number"]{
    -moz-appearance:textfield;/* firefox */
  }
}
.el-table{
  ::v-deep td{
    padding: 10px 0!important;
    vertical-align: top;
  }
}

</style>
